import { IsEnum, IsNotEmpty, IsUUID } from "class-validator";
import { AcceptanceOptionsEnum } from "../../enums";

export class StreamChatRequestDto {
  public id: string;
  public userId: string;
  public reviewerId: string;
  public chatCid: string;
  public statusId: AcceptanceOptionsEnum;
  public createdAt: Date;
  public updatedAt: Date;
}

export class AnswerRequestDto {
	@IsNotEmpty()
	@IsUUID()
	@IsEnum(AcceptanceOptionsEnum)
	statusId: AcceptanceOptionsEnum;
}
